<template>
  <div class="layerPop" v-if="isVisible">
    <div class="popWrap">
      <div class="popBox popType1">
        <div class="popHead">
          <p class="popTit">도시국가코드 조회</p>
        </div>
        <div class="popCon">
          <div class="conStyle1">
            <p class="tit mgt0">
              찾고자 하는 국가명의 영문 첫문자를 선택하신후 도시명을 선택하세요.
            </p>
          </div>

          <div class="sortWrap mgt30">
            <dl>
              <dt>검색조건</dt>
              <dd>
                <div class="split">
                  <div class="inpSlt">
                    <button type="button" class="sltBtn" title="조건 선택">
                      <span>선택</span>
                    </button>
                    <ul>
                      <li
                        v-for="(d, index) in state.getLrgMenuCityCodeList"
                        :key="index"
                      >
                        <button
                          type="button"
                          class="sltOpt"
                          title="선택"
                          @click="onClickLv1Item(d)"
                        >
                          <span>{{ d.name }}</span>
                        </button>
                      </li>
                      <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                    </ul>
                  </div>
                  <div class="inpSlt">
                    <button type="button" class="sltBtn" title="조건 선택">
                      <span>선택</span></button
                    ><!-- 조건 안될시 disabled -->
                    <ul>
                      <li
                        v-for="(d, index) in state.getMctgMenuCityCodeList"
                        :key="index"
                      >
                        <button
                          type="button"
                          class="sltOpt"
                          title="선택"
                          @click="onClickLv2Item(d)"
                        >
                          <span>{{ d.NTN_NM }}</span>
                        </button>
                      </li>
                      <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                    </ul>
                  </div>
                </div>
              </dd>
            </dl>
          </div>
          <div class="conStyle1">
            <p class="tit mgt0">도시를 선택하세요.</p>
          </div>
          <div class="tabStyle2">
            <table>
              <caption>
                조회결과
              </caption>
              <colgroup>
                <col width="200" />
                <col width="*" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">코드</th>
                  <th scope="col">국가명/도시명</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(d, index) in state.cityCodeOutputVoList2"
                  :key="index"
                >
                  <td>
                    <button type="button" @click="send(d)">
                      {{ d.CITY_NTN_CD }}
                    </button>
                  </td>
                  <td>
                    <button type="button" @click="send(d)">
                      {{ d.CITY_NTN_NM }}/{{ d.NTN_NM }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="popBtn">
          <a class="btnType sizeS colorB" @click="send()"><span>확인</span></a>
        </div>
        <slot></slot>
        <button type="button" class="popClose" @click="close()">
          <span class="hide">닫기</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, reactive, inject, defineExpose } from "vue";

import * as codeList from "@/common/code";

const axios = inject("axios");
const swalAlert = inject("swalAlert");

const state = reactive({
  getLrgMenuCityCodeList: [], //도시대뷴류 코드
  getMctgMenuCityCodeList: [], //도시중분류 코드

  cityCodeOutputVoList2: [], //상세코드 리스트
});
const isVisible = ref(false);

const emits = defineEmits(["update:data", "close"]);

const open = () => {
  isVisible.value = true;
};

const onClickLv1Item = async (d) => {
  let param = {
    az: d.code,
  };

  let result = await axios.json("/getStep1List.do", param);
  state.getMctgMenuCityCodeList = result.data.cityCodeOutputVoList;
};

const onClickLv2Item = async (d) => {
  let param = {
    ax: d.NTN_NM,
  };

  let result = await axios.json("/getStep2List.do", param);

  state.cityCodeOutputVoList2 = result.data.cityCodeOutputVoList2;
};

const send = (d) => {
  const data = { d };
  emits("update:data", data);
  isVisible.value = false;
};

const close = () => {
  isVisible.value = false;
  emits("close");
};

async function init() {
  state.getLrgMenuCityCodeList = codeList.getLrgMenuCityCode;
}

init();

defineExpose({ open, close });
</script>
